import auth from 'src/router/auth'
import Permission from '../Permission'
import NewPermission from '../NewPermission'
export default [
  {
    path: '/permissions',
    name: 'permission',
    component: Permission,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/permissions/new',
    name: 'create-permission',
    component: NewPermission,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/permission/routes/index.js